// extracted by mini-css-extract-plugin
export default {"columns":"Columns_columns__mnBqX","column":"Columns_column__GPYLF"};